var _defs, _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1c03cc00-2979-4144-95da-49cb7d38f95e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1090.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #dee2e6;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#Degradado_sin_nombre);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    "data-name": "Degradado sin nombre",
    x1: -242.74,
    y1: 1055.74,
    x2: 348.95,
    y2: 1000,
    gradientTransform: "translate(0 1090) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#270233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5c012d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#840029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9c0026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a50026"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 29.16,
    y: 29.16,
    width: 1021.68,
    height: 1021.68
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0.25,
    y: 0.25,
    width: 1079.5,
    height: 1079.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1079.5.5v1079H.5V.5h1079M1080,0H0v1080h1080V0h0Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 1080,
    height: 216
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.0151e729f74039cc5b4f9a9504d0065b.svg";
export { ForwardRef as ReactComponent };